import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from '../../utils/auth';
import { AppRoutes } from '../../constants/routes';

/**
 * Route guard that allows both creators and listeners to access listening features
 * Only blocks unauthenticated users
 */
const ListeningRoute = ({ children }) => {
  const { isAuthed, userType, isLoading, isListening } = useAuthProvider();
  const location = useLocation();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        color: 'white'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthed) {
    return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
  }

  // Creators, listeners and labels always; other account types from their
  // listening mode
  if (userType === 'creator' || userType === 'listener' || userType === 'label' || isListening) {
    return children;
  }

  // Fallback - redirect to login if user type is unknown
  return <Navigate to={AppRoutes.LoginPage} state={{ from: location }} replace />;
};

export default ListeningRoute;
